import styled from "styled-components";
import { Container, Col, Image, Button } from "react-bootstrap";

export const CardWrapper = styled.div`
  position: relative;
  padding: 0px; 
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: flex-start;
  text-align: center;
  width:100%;
  margin: auto; 
  overflow-y:auto; 
  @media (max-width: 750px) {
    flex-direction: column;
    text-align: center;
    padding: 0px;
    align-items: flex-start;
    height:max-content;
    padding-bottom: 15%;
    justify-content: center;
    overflow-x: hidden;
  }
  @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    height:75vh;
  }
`;

export const ImageCol = styled(Col)`
  
 display: flex;
 justify-content: center;
 align-items: center;
 margin-bottom: 20px;
 margin-right: 20px;
 flex: 0 0 25%;
 max-width:25%;

 @media (max-width: 750px) {
 margin-bottom: 0;
 margin-right: 0;
 max-width:100%;
 flex: 0 0 100%;
}
@media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    max-width:100%;
    flex: 0 0 100%;
    padding:1rem 0;
  }
`;

export const StyledImage = styled(Image)`
  width: 100%;
  object-fit: cover;
  border-radius: 15px;
  border:7px solid rgba(55, 146, 185, 1);
  border-radius:24px !important;
  height:20rem;
  background-color:#fff;
  @media (max-width: 750px) {
    width: 45%;
    height: 12rem;
    border: 7px solid rgba(55, 146, 185, 1);
  }
  @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    width: 52%;
    height:20rem;
    border: 5px solid rgba(55, 146, 185, 1);
  }

`;

export const ContentCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  align-items: flex-start; 
  flex: 0 0 70%;
  max-width:70%;
  background-color:#fff;
  @media (max-width: 750px) {
    align-items: center;  
    max-width:100%;
    flex: 0 0 100%;
  }
  @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    max-width:100%;
    flex: 0 0 100%;
  }
`;

export const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 15px;
  text-align:left;
  padding:0.5rem 0;
  background-color:#fff;
  span {
    color:rgba(255, 107, 0, 1);
  }
  strong {
    color:rgba(255, 107, 0, 1);
  }

  @media screen and (max-width: 750px) {
    font-size: 2rem;
    text-align:center;
  }
  @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    font-size: 2rem;
    text-align:center;
  }
`;

export const Message = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 25px;
  text-align:left;

  @media screen and (max-width: 750px){
    font-size: 1rem;
    text-align:center;
  }
  @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    font-size: 1rem;
    text-align:center;
  }
`;

export const ActionButton = styled(Button)`
  background: rgba(246, 103, 0, 1);
  color: white;
  padding: 12px 25px;
  border-radius: 8px;
  border: 1px solid #FF6B00;
  box-shadow: 0px 2px 15px 0px #00000026;
  font-family: Lato;
  font-weight: 700;
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: 0%;
  position:absolute;
  min-height:48px;
  bottom:2px;
  &:hover,
  &:focus,
  &:active,
  &.active,
  &:focus-visible {
  background: rgba(246, 103, 0, 1) !important;
  border-color: rgba(255, 107, 0, 1) !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
  }
  @media (max-width: 750px) {
    width:98%;
    margin:0 auto;
    bottom:0%;
    position:relative;
  }
  @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    bottom:0%;
    position:relative;
    padding: 0.75rem 3rem;
  }
`;

// --- Slider/Container Styled Components ---

export const DisplayContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0 20px;
  position: relative;
  
`;

export const SliderContentWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  position: relative;
  overflow: hidden;
`;

export const SlideWrapper = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(-${props => props.currentIndex * 100}%);
  width: ${props => props.totalSlides * 100}%;
`;

export const SliderCardWrapper = styled.div`
  flex: 0 0 100%;
//   padding: 10px;
  box-sizing: border-box;
`;

export const NavButton = styled(Button)`
  background-color: ${props => props.isHighlighted ? "#FF6B00" : "rgb(246, 103, 0)"};
  border: 1px solid ${props => props.isHighlighted ? "#FF6B00" : "#ddd"};
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  transform: translateY(-50%);
  z-index: 10;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: ${props => props.isHighlighted ? "white" : "#333"}; 
  font-size: 1.2rem;
  cursor: pointer;
  pointer-events: ${props => props.disabled ? "none" : "auto"}; 
  opacity: ${props => props.disabled ? 0.5 : 1}; 

  &:hover {
    background-color: ${props => props.isHighlighted ? "#FF6B00" : "rgba(255, 255, 255, 1)"};
    border-color: ${props => props.isHighlighted ? "#FF6B00" : "#E0523C"}; 
  }
  &:active {
    background-color: ${props => props.isHighlighted ? "#FF6B00" : "rgba(255, 255, 255, 1)"};
    border-color: ${props => props.isHighlighted ? "#FF6B00" : "#E0523C"}; 
  }

  &.left {
    right: 100px;
    @media screen and (max-width:750px){
      left: 35%;
      bottom: -1%;  
    }
    @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      left: 38%;
      bottom: -2%;
    }
  }

  &.right {
    right: 20px;
    width:80px;
    height:45px;
    border-radius:20px;
    @media screen and (max-width:750px){
      right: 27%;
      bottom: -1%; 
    }
    @media only screen and (min-device-width: 751px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      right: 33%;
      bottom: -2%;
    }
  }
  
   &.left[disabled],
   &.right[disabled] {
   background-color: white !important;
   color: grey !important;
   border-color: #ccc !important;
  }


`;

export const AddChildCloseIcon = styled.div`
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    cursor: pointer;
    margin-top: 5px;
    margin-right: 15px;
`
export const ProjectCelebration = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width:40%;
    flex-flow: column;
    margin: 0 auto;
    text-align: center;
    margin-top:3rem;
    @media only screen and (max-width:750px){
      width: 92%;
      margin: 0 auto;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    width:80%;
    margin-top:0;
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 1) {
    width:50%;
    margin-top:0;
    position: relative;
    top: -2rem;
  }
   @media screen and (min-width: 1200px) and (max-width:1400px) {
    margin-top:2rem;
    width:50%;
  }
  @media screen and (min-width: 1400px) and (max-width:1600px) {
    margin-top:2.25rem;
    width:45%;
  }
  @media screen and (min-width: 1600px) and (max-width:1920px) {
    margin-top:5rem;
  }
`
export const ProjectTitle = styled.h2`
font-size: 2rem;
font-weight: 700;
color: #fff;
margin-bottom: 1.5rem;
//background-color:${props=> !props.isDay? "#56a0e4":"transparent"};
@media screen and (min-width: 1200px) and (max-width:1400px) {
  font-size: 1.5rem;
  line-height:140%;
  margin-bottom: 0.75rem;  
}
@media screen and (min-width: 1400px) and (max-width:1600px) {
  font-size: 1.75rem;
  line-height:150%;
  margin-bottom: 0.75rem;  
}
@media only screen and (max-width:750px){
  font-size: 1.5rem;
}
`

export const ProjectDescription = styled.p`
font-family: Lato;
font-weight: 500;
font-size: 1.2rem;
line-height: 140%;
letter-spacing: 0%;
text-align: center;
color: #fff;
margin-bottom: 1.5rem;
@media screen and (min-width: 1200px) and (max-width:1400px) {
  font-size: 1rem;
  margin-bottom: 12px;  
} 
@media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 1) {
    display:none;
  }
`

export const CelebrateButton = styled.button`
background: rgba(255, 107, 0, 1);
border: 1px solid rgba(255, 255, 255, 1);
border-radius: 8px;
padding:10px 15px;
box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
font-size:1.2rem;
color:#fff;
font-weight:700;
 & span {
  margin-right:10px;
  & img {
    transform: rotate(352deg);
    width: 30px;
    margin-top: -4px;
  }
}
@media screen and (min-width: 1200px) and (max-width:1400px) {
  font-size: 0.9rem;
  margin-bottom: 12px;  
  & span {
    margin-right:10px;
    & img {
      transform: rotate(352deg);
      width: 25px;
      margin-top: -4px;
    }
  }
} 

`